import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  change?: {
    value: string | number;
    positive?: boolean;
    prefix?: string;
  };
  footer?: React.ReactNode;
  icon?: React.ReactNode;
  loading?: boolean;
}
export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  footer,
  icon,
  loading = false
}) => {
  if (loading) {
    return <LoadingCard data-id="element-61" />;
  }
  return <div className="bg-white rounded-lg p-5 shadow-sm transition-all duration-200 hover:shadow-md hover:scale-102 animate-slide-in" data-id="element-62">
      <div className="flex items-center mb-3" data-id="element-63">
        {icon && <div className="mr-3 text-gray-400 bg-gray-50 p-2 rounded-lg" data-id="element-64">
            {icon}
          </div>}
        <h3 className="text-sm font-medium text-gray-500" data-id="element-65">{title}</h3>
      </div>
      <div className="text-3xl font-semibold mb-2" data-id="element-66">{value}</div>
      {change && <div className="flex items-center text-sm" data-id="element-67">
          {change.positive !== undefined && <span className={`mr-1 ${change.positive ? 'text-green-500' : 'text-red-500'}`} data-id="element-68">
              {change.positive ? <ArrowUpIcon size={16} data-id="element-69" /> : <ArrowDownIcon size={16} data-id="element-70" />}
            </span>}
          <span className={change.positive ? 'text-green-500' : 'text-red-500'} title={`Change: ${change.prefix || ''}${change.value}`} data-id="element-71">
            {change.prefix || ''}
            {change.value}
          </span>
          <span className="text-gray-500 ml-1" data-id="element-72">vs last month</span>
        </div>}
      {footer && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-73">{footer}</div>}
    </div>;
};